const INITIAL_STATE = {
  branchesList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_BRANCHES': {
      return { ...state, branchesList: action.branches };
    }
    default:
      return state;
  }
};
